module.exports = {"username":"Usuário","password":"Senha","logIn":"Entrar","allRightsReserved":"{name} © Direitos reservados {date}","noMatch":"O nome de usuário e a senha não correspondem"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/pt.json
// module id = 815
// module chunks = 0